<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import Modal from './Modal.svelte';
    import Button from './forms/Button.svelte';

    export let open           = false;
    export let title          = 'Confirm';
    export let message        = '';
    export let confirmLabel   = 'Confirm';
    export let cancelLabel    = 'Cancel';
    export let destructive    = false;   // red confirm button for dangerous actions

    const dispatch = createEventDispatcher<{ confirm: void; cancel: void }>();

    function onConfirm() {
        open = false;
        dispatch('confirm');
    }

    function onCancel() {
        open = false;
        dispatch('cancel');
    }
</script>

<Modal bind:open {title} size="sm" on:close={onCancel}>
    <p class="confirm-message">{message}</p>
    <slot />

    <svelte:fragment slot="footer">
        <Button variant="default" on:click={onCancel}>{cancelLabel}</Button>
        <Button variant={destructive ? 'danger' : 'primary'} on:click={onConfirm}>{confirmLabel}</Button>
    </svelte:fragment>
</Modal>

<style lang="scss">
    .confirm-message {
        margin: 0;
        color: $color-text;
    }
</style>
